import React, { useMemo, useState } from "react";
import styles from "./Card.module.css";
import { QuantidadeAnimada, ValorAnimado } from "../../../components/QtdValorAnimados";
import DoughnutChart2 from "../../../components/DoughnutChart2";
import { FaChevronDown } from "react-icons/fa";

const Card = ({ empresa }) => {
  const [open, setOpen] = useState(false);

  const labelTabela = useMemo(() => {
    if (empresa.tabela_preco === 3) return "VAREJO S1 (Tabela 3)";
    if (empresa.tabela_preco === 7) return "VAREJO PADRÃO (Tabela 7)";
    if (empresa.tabela_preco === 10) return "ATACADO (Tabela 10)";
    if (empresa.tabela_preco === 12) return "VAREJO S2 (Tabela 12)";
    return "-";
  }, [empresa.tabela_preco]);

  const qtdDistrib = Math.max(0, empresa.qtd_total - empresa.qtd_fisico - empresa.qtd_consignado);
  const valDistrib = Math.max(0, empresa.valor_total - empresa.valor_fisico - empresa.valor_consignado);

  return (
    <div className={`${styles.card} ${open ? styles.open : ""}`}>
      <div className={styles.cardHeader}>
        <div className={styles.headerTop}>
          <h2>{empresa.nome_empresa}</h2>

          <button
            type="button"
            className={styles.toggleBtn}
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls={`card-details-${empresa.empresa}`}
          >
            <span className={styles.toggleText}>
              {open ? "Menos detalhes" : "Mais detalhes"}
            </span>

            <span className={styles.chevron} aria-hidden="true">
              <FaChevronDown />
            </span>
          </button>
        </div>

        <p className={styles.empresaInfo}>ID: <span>{empresa.empresa}</span></p>
        <p className={styles.empresaInfo}>Setor: <span>{empresa.setor}</span></p>
        <p className={styles.empresaInfo}>Região: <span>{empresa.regiao}</span></p>
        <p className={styles.empresaInfo}>Valores: <span>{labelTabela}</span></p>

        <div className={styles.totaisPrincipais}>
          <p className={styles.qtdTotal}>
            <QuantidadeAnimada de={0} para={empresa.qtd_total} /> peças
          </p>

          <p className={styles.valorTotal}>
            <ValorAnimado de={0} para={empresa.valor_total} />
            <span style={{ fontWeight: "normal", fontSize: "12px" }}>
              &nbsp;{empresa.empresa === 14 ? "- Valor aproximado após o banho" : ""}
            </span>
          </p>
        </div>

        {empresa.empresa === 14 && (
          <p className={styles.custoBruto}>
            <strong>Custo Bruto</strong>
            <br />
            <ValorAnimado de={0} para={empresa.custo_bruto_total} />
          </p>
        )}
      </div>

      {/* Tudo que deve abrir/fechar fica aqui dentro */}
      <div
        id={`card-details-${empresa.empresa}`}
        className={styles.collapse}
        data-open={open ? "1" : "0"}
      >
        <div className={styles.collapseInner}>
          <div className={styles.secundarios}>
            <div>
              <strong>Disponível</strong>
              <p><QuantidadeAnimada de={0} para={empresa.qtd_fisico} /> peças</p>
              <p><ValorAnimado de={0} para={empresa.valor_fisico} /></p>
              <DoughnutChart2
                valor={empresa.qtd_fisico}
                total={empresa.qtd_total}
                cor="#8adbad"
                label="Disponível"
              />
            </div>

            <div>
              <strong>Em terceiros</strong>
              <p><QuantidadeAnimada de={0} para={empresa.qtd_consignado} /> peças</p>
              <p><ValorAnimado de={0} para={empresa.valor_consignado} /></p>
              <DoughnutChart2
                valor={empresa.qtd_consignado}
                total={empresa.qtd_total}
                cor="#d8b176"
                label="Em terceiros"
              />
            </div>

            <div>
              <strong>{empresa.empresa === 14 ? "Processo de banho" : "Em distribuição"}</strong>
              <p><QuantidadeAnimada de={0} para={qtdDistrib} /> peças</p>
              <p><ValorAnimado de={0} para={valDistrib} /></p>
              <DoughnutChart2
                valor={qtdDistrib}
                total={empresa.qtd_total}
                cor="#d8b176"
                label="Em distribuição"
              />
            </div>
          </div>

          <div className={styles.grupos}>
            {empresa.grupos_pai.map((grupo, gidx) => (
              <div key={gidx} className={styles.grupo}>
                <h4 className={styles.grupoTitulo}>{grupo.grupo_pai}</h4>
                <div className={styles.total}>
                  <span className={styles.totalInfo}>
                    {grupo.qtd_total} peças / R$
                    {grupo.valor_total.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </span>
                </div>
                <div className={styles.subItem}>
                  <strong>Disponível:</strong> {grupo.qtd_fisico} peças / R$
                  {grupo.valor_fisico.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                </div>
                <div className={styles.subItem}>
                  <strong>Em terceiros:</strong> {grupo.qtd_consignado} peças / R$
                  {grupo.valor_consignado.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;